import {
  mapDispatchToPropsCityStateZip,
  mapDispatchToPropsIsSpouseSameAddress,
  mapStateToPropsCityStateZip
} from 'reg_redesign/redux/connectFunctions';
import BasicCheckbox from 'components/component_lib/BasicCheckbox';
import BasicInput from '@opploans/basic-input-component/BasicInput';
import CityStateZip from 'reg_redesign/CityStateZip';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

export default {
  defaultNextPage: 'page-6',
  content: [
    configureProgressBar(22),
    configureTitle('Where does your spouse live?'),
    {
      component: BasicInput,
      name: 'spouseAddress',
      props: {
        id: 'spouseAddress',
        label: 'Street Address',
        InputProps: {},
        formControlStyle: {
          marginBottom: '1.5rem'
        }
      }
    },
    {
      component: CityStateZip,
      name: 'spouseCityStateZip',
      stateToPropsOverride: mapStateToPropsCityStateZip,
      dispatchOverride: mapDispatchToPropsCityStateZip,
      props: {
        cityId: 'spouseCity',
        stateId: 'spouseState',
        zipId: 'spouseZip',
        idsToValidate: ['spouseCity', 'spouseState', 'spouseZip']
      }
    },
    {
      component: BasicCheckbox,
      name: 'isSpouseAddressSame',
      dispatchOverride: mapDispatchToPropsIsSpouseSameAddress,
      props: {
        id: 'isSpouseAddressSame',
        label: 'Same as my address',
        formControlStyle: {
          marginBottom: '1.5rem'
        }
      }
    },
    nextButtonConfig('page-5.3')
  ]
};
